import { useGetUniqueVariableName } from "./useGetUniqueVariableName";

/**
 * Given a list of existing Explore cell result variables,
 * will generate a new list with names that are unique across the entire project
 */
export function useGetUniqueExploreResultVariables() {
  const getUniqueExploreVariable = useGetUniqueVariableName("ExploreCell");

  return (
    originalVariables: readonly string[],
    additionalExistingNames: string[] = [],
  ): string[] => {
    const acc: string[] = [];
    for (const name of originalVariables) {
      const newName = getUniqueExploreVariable(name, [
        ...additionalExistingNames,
        ...acc,
      ]);
      acc.push(newName);
    }
    return acc;
  };
}
